import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeBaseUserAvatarProps } from "@/__mocks__/mockBaseTypes";
import { HeaderDecorator } from "@/__stories__/Decorator";
import type { ChannelHeaderProps } from "@/ui/components/messages/ChannelHeader";
import ChannelHeader from "@/ui/components/messages/ChannelHeader";

const mockAvatarUsers = faker.helpers.multiple(
  () => fakeBaseUserAvatarProps(),
  {
    count: { max: 10, min: 2 },
  },
);

const StoryMeta: Meta<ChannelHeaderProps> = {
  title: "Components/Messages/Channel Header",
  component: ChannelHeader,
  argTypes: {
    channelName: { control: "text" },
    channelUrl: { control: "text" },
    isGroupChannel: { control: "boolean" },
    members: { control: "object" },
    onDetailsPress: { action: "details pressed" },
    onDismiss: { action: "dismissed" },
  },
  args: {
    channelName: "Provider Team",
    channelUrl: "provider-team",
    members: mockAvatarUsers,
  },
  decorators: [(story) => <HeaderDecorator>{story()}</HeaderDecorator>],
};

type Story = StoryObj<ChannelHeaderProps>;

export const Primary: Story = {};
export default StoryMeta;
